<template>
  <div>
    <!-- <h1>editor_initial_scenarios</h1> -->
    <section v-if="!isAdvancedMode">
      <h6 class="text-h6">Ajouter un scénario</h6>
      <p>Un scénario initial est un ensemble d'éléments qui soutiennent une option et qui sont absolument nécessaires pour activer cette option (c'est-à-dire que si l'un de ces éléments est supprimé, l'option ne peut pas être activée).</p>

      <h6 class="text-h6">Gérer les éléments</h6>
      <p>Un élément de scénario est un morceau de connaissance (ou de fait) que nous savons être valide (ou vrai) (c'est-à-dire aujourd'hui est vendredi) et doit être fourni en entrée par l'utilisateur. Les éléments de scénario représentent les raisons pour lesquelles l'option soutenue devrait être choisie.</p>

      <h6 class="text-h6">Ajouter une option</h6>
      <p>Une option est une décision à prendre, une action à entreprendre, ou un objectif à atteindre.</p>

      <p>Pour déclarer qu'une option est toujours valide, vous créez un scénario <pre class="empty">Vide</pre> (cliquez sur <pre class="button"><v-icon small>mdi-plus-circle-outline</v-icon>AJOUTER UN SCENARIO</pre> puis sur <pre class="button"><v-icon small>mdi-content-save-outline</v-icon>SAUVEGARDER</pre>).
      </p>
    </section>
    <section v-else>
      <h6 class="text-h6">Ajouter un scénario</h6>
      <p>Un scénario initial est un ensemble d'éléments qui soutiennent une option et qui sont absolument nécessaires pour activer cette option (c'est-à-dire que si l'un de ces éléments est supprimé, l'option ne peut pas être activée).</p>

      <h6 class="text-h6">Gérer les éléments</h6>
      <p>Un élément de scénario est un morceau de connaissance (ou de fait) que nous savons être valide (ou vrai) (c'est-à-dire aujourd'hui est vendredi) et doit être fourni en entrée par l'utilisateur. Les éléments de scénario représentent les raisons pour lesquelles l'option soutenue devrait être choisie.</p>

      <p>Si vous choisissez de créer un scénario avec des expressions mathématiques (par exemple, <pre class="element">p(X),q(Y),X+Y>5</pre>) directement en <a href="https://www.swi-prolog.org">PROLOG</a>, vous avez deux possibilités :</p>

      <p>
        <ul>
          <li>
            Créez un élément pour chaque partie de l'expression (par exemple, un élément pour <pre class="element">p(X)</pre>, un élément pour <pre class="element">q(Y)</pre> et un élément pour <pre class="element">X+Y>5</pre>). Ensuite, vous allez à <pre class="button"><v-icon small>mdi-plus-circle-outline</v-icon>GERER LES ELEMENTS</pre> et vous décochez <pre><v-icon small>mdi-checkbox-blank-outline</v-icon>DONNEES D'ENTREE</pre> si ce n'est pas une information qui doit être fournie par l'utilisateur (par exemple, <pre class="element">X+Y>5</pre>).
          </li>

          <li>
            Créez un élément pour l'expression entière, puis cliquez sur le bouton <pre class="button"><v-icon small>mdi-plus-circle-outline</v-icon>GERER LES ELEMENTS</pre> pour le diviser en sous-éléments (un pour <pre class="element">p(X)</pre>, un pour <pre class="element">q(Y)</pre>, et un pour <pre class="element">X+Y>5</pre>). Ensuite, vous décochez <pre><v-icon small>mdi-checkbox-blank-outline</v-icon>DONNEES D'ENTREE</pre> si ce n'est pas une information qui doit être fournie par l'utilisateur (par exemple, <pre class="element">X+Y>5</pre>).
          </li>
        </ul>
      </p>

      <p>Si vous choisissez de créer un scénario avec des expressions mathématiques en langage naturel, alors vous cliquez sur le bouton <pre class="button"><v-icon small>mdi-plus-circle-outline</v-icon>&nbsp;GERER LES ELEMENTS</pre> et vous personnalisez la représentation automatisée des expressions en <a href="https://www.swi-prolog.org">PROLOG</a>, comme indiqué ci-dessus.</p>

      <p>Vous pouvez cliquer sur le bouton <pre class="button"><v-icon small>mdi-plus-circle-outline</v-icon>GERER LES ELEMENTS</pre> et personnaliser toute représentation automatisée des éléments.</p>

      <h6 class="text-h6">Ajouter une option</h6>
      <p>Une option est une décision à prendre, une action à entreprendre, ou un objectif à atteindre.</p>

      <p>Pour déclarer qu'une option est toujours valide, vous créez un scénario <pre class="empty">Vide</pre> (cliquez sur <pre class="button"><v-icon small>mdi-plus-circle-outline</v-icon>AJOUTER UN SCENARIO</pre> puis sur <pre class="button"><v-icon small>mdi-content-save-outline</v-icon>SAUVEGARDER</pre>).</p>
    </section>
  </div>
</template>
<script>
export default {
  computed: {
    isAdvancedMode () {
      return this.$store.state.mode === 'advanced'
    },
  },
}
</script>
